module.exports = __webpack_public_path__ + "img/DE00495.f66a3d54.png";